/**
 * feature-config flag names related to logic deprecation
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 *
 * Once Logic has been fully deprecated and the code and infrastructure have been removed, we can remove this file as well
 */

export const LOGIC_DEPRECATION_FLAG_NAMES = {
  LOGIC_DEPRECATION: 'ff-op-2087-logic-deprecation',
};
